
import Vue from 'vue'
import PriceLabel from '@/components/PriceLabel.vue'
import BaseImage from '@/components/BaseImage.vue'
import { formatOneDecimal } from '@/utils/common'
import { SVG_PLACEHOLDER_IMAGES } from '@/constants'

export default Vue.extend({
  components: {
    PriceLabel,
    BaseImage
  },
  props: {
    alt: {
      type: String,
      required: true
    },
    itemUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    originalPrice: {
      type: Number,
      required: true
    },
    campaignPrice: {
      required: true,
      validator: v => typeof v === 'number' || v === null
    },
    minQuantity: {
      type: Number,
      required: false,
      default: undefined
    },
    quantity: {
      type: Number,
      required: false,
      default: undefined
    },
    unit: {
      type: String,
      required: true
    },
    lead: {
      type: String,
      required: false,
      default: undefined
    }
  },
  computed: {
    hasCampaignPrice(): boolean {
      return !!this.campaignPrice
    },
    price(): number {
      return this.campaignPrice || this.originalPrice
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  },
  methods: {
    formatOneDecimal
  }
})
